<template>
  <vx-card>
    <div class="flex justify-between">
      <a-button type="link" class="p-0 text-primary" ghost @click="$router.push('/task/list')"><a-icon type="left" />Back to Tasks</a-button>
      <a-button type="primary" ghost class="add-type" @click="showModal">Add</a-button>
    </div>

    <XTable
      :model="model"
      @clickRow="clickTempRow"
      class="mt-5"
      ref="taskType"
      :options="{placeholder:'Search task type',noContent: 'No tasks',is_row_selection: false,is_load_req: true}"
    >
       <span slot="action" slot-scope="text,record" class="flex space-x-3">
         <a-dropdown>
           <a-menu slot="overlay">
             <a-menu-item key="1" @click="editType(text.record)"> <a-icon type="edit" />Edit</a-menu-item>
             <a-menu-item key="2" @click="deleteTaskType(text.record)"> <a-icon type="delete" />Delete</a-menu-item>
           </a-menu>
           <a-button style="margin-left: 8px" @click="is_click_add_time = false"> Actions <a-icon type="down" /> </a-button>
         </a-dropdown>
       </span>
       <span slot="date_create" slot-scope="text,record" class="flex space-x-3" v-if="text.record.creator">
          {{  text.record.creator ? new Date(text.record.creator.created_at).toLocaleString("en-GB", { timeZone: 'UTC' }) : '' }}
       </span>
    </XTable>

    <a-modal title="New Task" :visible="openTaskType" @cancel="openTaskType = false">
       <a-form-item>
         <a-input
           v-model="title"
           placeholder="Enter Input Title..."
         />
       </a-form-item>
      <a-divider/>
      <div class="flex space-x-2">
          <a-button class="add-type" type="primary" @click="addType" :disabled="disabledType">Save</a-button>
          <a-button class="add-type" type="primary" ghost @click="openTaskType = false">Cancel</a-button>
      </div>
    </a-modal>

    <deleteItem
      :url="`/task/task-type/${temp_row}/`"
      subject="Task type"
      :ele="$refs.taskType"
      ref="taskDelete"
    />

  </vx-card>

</template>

<script>
  import XTable from '../../components/x-table/XTable'
  import * as TableCol from './taskTypeTbl'
  import axios from '@/axios'
  import deleteItem from '../communications/deleteItem'
  import mixin from '../mixin/mixin'


  export default {
    name: "TaskType",
    mixins:[mixin],
    components:{
      XTable,
      deleteItem
    },
    data(){
      return{
        model: null,
        title: null,
        openTaskType: false,
        temp_row: undefined,
        mode_edit: false
      }
    },
    methods:{

      showModal(){
        this.mode_edit = false
        this.openTaskType = true
      },

      deleteTaskType(record){
        this.temp_row = record.id
        this.$refs.taskDelete.open = true
      },

      editType(record){
        this.temp_row = record.id
        this.mode_edit = true
        this.openTaskType = true
        this.title = record.title
      },

      async addType(){
        try{
          this.$vs.loading()
          const whichUrl = this.mode_edit ? `/task/task-type/${this.temp_row}/` : '/task/task-type/'
          await axios.put(whichUrl,{title:this.title})
          this.openTaskType = false
          this.$notification['success']({
            message: 'Success',
            description: `Task type ${this.mode_edit ? 'updated' : 'created'}.`,
          });
          this.title = null
          this.$refs.taskType.fetch().then(()=>{})
        }catch (e) {
          this.$notification['error']({
            message: 'error',
            description: `Task type failed.`,
          });
          this.openTaskType = true
        }finally {
          this.$vs.loading.close()
        }
      },

      clickTempRow(record){
        this.edit_mode = true
        if(this.is_click_add_time){
          this.openTaskType  = true
          this.temp_row = record.id
          this.title = record.title
        }else
          this.is_click_add_time = true
      }
    },
    computed:{
      disabledType(){
        return !this.title
      }
    },
    mounted() {
      this.is_click_add_time = true
    },
    created() {
      this.model = TableCol.default
    }
  }
</script>

<style>
  @import "../style/style.css";
  .add-type{
    border-radius: 3px !important;
  }
  .ant-modal-footer{
    display: none !important;
  }
</style>
